{
  "nl": {
    "milestone": {
      "actions": {
        "activate": "Activeer",
        "active": "Actief!",
        "create": "Mijlpaal aanmaken",
        "deactivate": "Deactiveer",
        "delete": "Verwijder",
        "delete_milestones": "Mijlpaal verwijderen | {count} mijlpalen verwijderen",
        "new": "Mijlpaal"
      },
      "labels": {
        "bulk_assign_title": "Selecteer units waaraan u mijlpaal '{milestone_name}' wilt toewijzen",
        "edit_milestone": "Mijlpaal bewerken",
        "edit_units": "Units bewerken",
        "empty_state_subtitle": "Mijlpalen maken het bouwproces transparanter voor woningkopers",
        "empty_state_title": "Maak een nieuwe mijlpaal aan",
        "future_milestones": "Toekomstige mijlpalen",
        "milestone": "Mijlpaal",
        "milestone_name": "Naam van mijlpaal",
        "milestone_unit_count": "0 units | 1 unit | {count} units",
        "milestones": "Mijlpalen",
        "new_milestone": "Nieuwe mijlpaal",
        "no_milestone": "Nog geen mijlpaal toegewezen",
        "no_results": "Geen mijlpalen gevonden",
        "past_milestones": "Eerdere mijlpalen",
        "please_select": "Selecteer een nieuwe mijlpaal",
        "position": "Positie",
        "search_empty_state": "Nog geen mijlpalen aangemaakt. Klik hier om te starten",
        "units": "Units",
        "units_without_milestone": "1 unit zonder mijlpaal | {count} units zonder mijlpaal",
        "warning_delete": "Als u een mijlpaal verwijdert die aan een unit is toegewezen zal deze klant geen mijlpalen meer zien. Zorg ervoor dat u een nieuwe mijlpaal toewijst aan deze units!"
      },
      "toasts": {
        "bulk_assigned": "De mijlpaal is succesvol toegewezen aan de geselecteerde units",
        "create_success": "Mijlpaal succesvol aangemaakt",
        "deactivate_success": "Mijlpaal is succesvol gedeactiveerd",
        "sup_assigned": "De mijlpaal is succesvol geactiveerd",
        "update_success": "Mijlpalen zijn succesvol bijgewerkt"
      },
      "validation": {
        "needName": "Naam is verplicht",
        "needNamePrimary": "De naam in de primaire taal ({language}) is verplicht"
      }
    }
  }
}
